import {
  AllOtherPerilsDeductible,
  CoverageBoolean,
  CoverageDebrisRemovalValue,
  CoverageDLossOfUseValue,
  CoverageEarthquakeValue,
  CoverageELiabilityValue,
  CoverageEquipmentBreakdownValue,
  CoverageFMedicalPaymentToOthersValue,
  CoverageGolfCartValue,
  CoverageInflationGuardValue,
  CoverageLossAssessmentValue,
  CoverageScheduledPersonalPropertyItem,
  CoverageSecondaryResidenceLiabilityAddress,
  CoverageWaterBackupAndSumpOverflowValue,
  CoverageWaterDamageValue,
  ResidenceBurglaryValue,
  WaterDamageDeductible,
  WindHailDeductible,
  Maybe,
} from "@covertree/new-business-graphql";
import { PackageCoverageOptions } from "./packageCoverages/types";
import { ExtraCoverageOptions } from "./extraCoverages/types";
import { ExtraCoverageAccessor, PackageCoverageAccessor } from "../..";

enum ScreenWithCoverages {
  PlanDetails = "Plan Details",
  ExtraCoverages = "Extra Coverages",
  PolicySummary = "Policy Summary",
}

enum CoverageLevel {
  Policy = "policy",
  Unit = "unit",
}

enum ExtensionCoverageAccessor {
  AnimalLiability = "animalLiability.value",
  DamageToPropertyOfOthers = "damageToPropertyOfOthers.value",
  FungiWetOrDryRotOrBacteriaProperty = "fungiWetOrDryRotOrBacteriaProperty.value",
}

type PartialScreenWithCoveragesRecord = {
  [key in ScreenWithCoverages]?: string;
};

type OptionRecord<Option extends string, Value> = {
  Default: Value;
} & {
  [key in Exclude<Option, "Default">]?: Value;
};

type CoverageAccessor =
  | PackageCoverageAccessor
  | ExtraCoverageAccessor
  | ExtensionCoverageAccessor;

type CoverageOptions = PackageCoverageOptions & ExtraCoverageOptions;

type GetOptionalWithOptions = (options?: CoverageOptions) => string | undefined;

type GetRequiredWithOptions = (options?: CoverageOptions) => string;

type CoverageValueFormats = {
  prefix?: string;
  value?: string;
  message?: string;
};

type GetValue<
  T extends
    | number
    | string
    | AllOtherPerilsDeductible
    | WindHailDeductible
    | WaterDamageDeductible
    | CoverageDLossOfUseValue
    | CoverageWaterDamageValue
    | CoverageELiabilityValue
    | CoverageInflationGuardValue
    | CoverageFMedicalPaymentToOthersValue
    | CoverageGolfCartValue
    | CoverageEarthquakeValue
    | CoverageWaterBackupAndSumpOverflowValue
    | CoverageLossAssessmentValue
    | CoverageDebrisRemovalValue
    | CoverageEquipmentBreakdownValue
    | ResidenceBurglaryValue
    | CoverageScheduledPersonalPropertyItem[]
    | CoverageSecondaryResidenceLiabilityAddress[]
    | CoverageBoolean = never,
> = (value: number | string | Maybe<T>) => CoverageValueFormats | undefined;

type CoverageGetters = {
  getName: GetRequiredWithOptions;
  getDescription: GetOptionalWithOptions;
  getTooltip: GetOptionalWithOptions;
  getValueFormats: GetValue;
};

type Coverage = {
  accessor: CoverageAccessor;
  level: CoverageLevel;
  image: string;
} & CoverageGetters;

export {
  ScreenWithCoverages,
  CoverageLevel,
  ExtensionCoverageAccessor,
  type PartialScreenWithCoveragesRecord,
  type OptionRecord,
  type GetValue,
  type GetOptionalWithOptions,
  type GetRequiredWithOptions,
  type Coverage,
  type CoverageAccessor,
  type CoverageGetters,
  type CoverageOptions,
  type CoverageValueFormats,
};
